import RingBuffer from "src/modules/audio-processing/RingBuffer";
import addModuleToWorklet from "src/modules/audio-processing/addModuleToWorklet";
import createNoiseMeter from "src/modules/audio-processing/createNoiseMeter";
import { getModulePublicPathPrefix } from "src/utils/environment";

const BUFFER_SIZE = 1024;

export default class MicrophoneReader {
  constructor() {
    this.stream = null;
    this.opened = false;
    this.onData = (buffer) => {};
    this.releaseWorkletResources = () => {};
  }
  async open(constraints) {
    this.context = new AudioContext();

    this.stream = await navigator.mediaDevices.getUserMedia(constraints);

    if (this.stream == null) {
      throw new Error("cannot create stream");
    }
    const audioTrack = this.stream.getAudioTracks()[0];
    if (audioTrack == null) {
      throw new Error("no audio track available");
    }

    this.src_node = this.context.createMediaStreamSource(this.stream);
    const channelCount = this.src_node.channelCount;

    this.ringbuf = new RingBuffer(
      new Float32Array(BUFFER_SIZE * channelCount * 8)
    );

    this.releaseWorkletResources = await addModuleToWorklet(
      this.context.audioWorklet,
      getModulePublicPathPrefix() +
        "modules/audio-processing/worklets/microphone.js"
    );
    this.audioWorkletNode = new AudioWorkletNode(this.context, "microphone", {
      numberOfInputs: 1,
      numberOfOutputs: 1,
      channelCount
    });

    var tmp = 0;
    this.audioWorkletNode.port.onmessage = async (e) => {
      const { name, payload } = e.data;
      if (name === "data") {
        this.ringbuf.append(payload);

        if (tmp++ % 5 !== 0) return;

        if (!this.in_flight) {
          const data = await this.read();
          this.onData(data);
        }
      }
    };

    this.noiseMeter = await createNoiseMeter({
      audioContext: this.context,
      sourceNode: this.src_node
    });

    this.src_node
      .connect(this.audioWorkletNode)
      .connect(this.context.destination);
    this.src_node
      .connect(this.noiseMeter.audioNode)
      .connect(this.context.destination);

    this.read_unit = BUFFER_SIZE * channelCount;

    this.opened = true;
    return {
      samplingRate: this.context.sampleRate,
      numOfChannels: channelCount,
      noiseMeter: this.noiseMeter
    };
  }

  read() {
    this.in_flight = true;
    return new Promise((resolve, reject) => {
      var buf = new Float32Array(this.read_unit);
      var func = () => {
        var size = this.ringbuf.read_some(buf);
        if (size === 0) {
          window.setTimeout(function () {
            func();
          }, 10);
          return;
        }
        this.in_flight = false;
        resolve({
          timestamp: 0,
          samples: buf.subarray(0, size),
          transferable: true
        });
      };
      func();
    });
  }

  close() {
    this.opened = false;
    this.onData = () => {};
    this.ringbuf && this.ringbuf.clear();
    if (this.src_node) {
      this.src_node.disconnect();
      this.src_node = null;
    }
    if (this.audioWorkletNode) {
      this.audioWorkletNode.disconnect();
      this.audioWorkletNode = null;
    }
    if (this.noiseMeter) {
      this.noiseMeter.destroy();
    }
    this.context.close();
    this.context = null;
    this.releaseWorkletResources();

    if (this.stream) {
      const tracks = this.stream.getTracks();
      tracks.forEach((track) => {
        track.stop();
        track.enabled = false;
      });
    }
  }
  stop() {
    this.ringbuf && this.ringbuf.clear();
    return this.context.suspend();
  }
  resume() {
    this.context.resume();
  }
}
